import { Link } from "react-router";
import { ArrowLeft, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Main } from "@/components/shared/Main";
import { Header } from "@/components/shared/Header";
import { useApplicationContext } from "@/context/ApplicationContext";

export function DocsIndexPage() {
  const { allDocumentationPages } = useApplicationContext();

  return (
    <>
      <Header />
      <Main>
        <div className="mb-8">
          <Button asChild variant="ghost" className="mb-4">
            <Link to="/" className="flex items-center">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Link>
          </Button>

          <h1 className="text-4xl font-bold text-gray-900 mb-4">Documentation</h1>
          <p className="text-xl text-gray-600">Step by step guides for all Photon Flow scenarios</p>
        </div>

        <div className="space-y-6">
          {allDocumentationPages.map((doc) => (
            <div key={doc.id} className="border-b border-gray-200 pb-6 last:border-b-0">
              <div className="flex items-start space-x-3">
                <FileText className="w-5 h-5 text-blue-600 mt-1 shrink-0" />
                <div className="grow">
                  <Link
                    to={doc.docsPath}
                    className="text-xl font-semibold text-blue-600 hover:text-blue-800 hover:underline transition-colors"
                  >
                    {doc.title}
                  </Link>
                  <p className="text-gray-600 mt-2">{doc.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Main>
    </>
  );
}
